module.exports = __webpack_public_path__ + "img/product-beats-1.a8413c66.png";